// client/src/lib/pipelineStages.js
// Single source of truth for investor_pipeline.stage on the client — mirrors
// the CHECK constraint (see migrations/093_rename_stage_awaiting_client_approval.sql). Array
// order is the kanban column order.

export const PIPELINE_STAGES = [
  'Awaiting Client Approval',
  'Client-Approved for Outreach',
  'Initial Email / Teaser',
  'Initial Meeting Held',
  'NDA and Data Room',
  'In Diligence',
  'In Documentation',
  'Closed',
  'On Hold',
  'Passed',
  'Unresponsive',
]

// Stages a partner can't move a row into, or out of: RGA moves a name out
// of Awaiting Client Approval once the client signs off. Mirrors
// src/lib/pipelineStages.js.
export const PARTNER_LOCKED_STAGES = ['Awaiting Client Approval', 'Client-Approved for Outreach']

export const PL_BADGE = {
  'Awaiting Client Approval': 'badge-gray',
  'Client-Approved for Outreach': 'badge-teal',
  'Initial Email / Teaser':  'badge-blue',
  'Initial Meeting Held':    'badge-teal',
  'NDA and Data Room':       'badge-blue',
  'In Diligence':            'badge-yellow',
  'In Documentation':        'badge-purple',
  'Closed':                  'badge-green',
  'On Hold':                 'badge-orange',
  'Passed':                  'badge-red',
  'Unresponsive':            'badge-gray',
}

export const PL_ACCENT = {
  'Awaiting Client Approval': '#4b5563',
  'Client-Approved for Outreach': '#06b6d4',
  'Initial Email / Teaser':  '#3b82f6',
  'Initial Meeting Held':    '#14b8a6',
  'NDA and Data Room':       '#0ea5e9',
  'In Diligence':            '#f59e0b',
  'In Documentation':        '#8b5cf6',
  'Closed':                  '#10b981',
  'On Hold':                 '#f97316',
  'Passed':                  '#6b7280',
  'Unresponsive':            '#9ca3af',
}
